module.exports = __webpack_public_path__ + "static/media/kg.20cdf615.svg";